export const TAGS = [
  'Root',
  'Automated Deliveries',
  'AWS Locations',
  'Email Locations',
  'SFTP Locations',
] as const;
